module.exports = __webpack_public_path__ + "img/icon-wait.b49dd458.svg";